export class routes {
  public static get certificates(): string {
    return "/certificates";
  }
  public static get faculties(): string {
    return "/faculties";
  }
  public static get createFaculty(): string {
    return "/createFaculty";
  }
  public static get updateFaculty(): string {
    return "/updateFaculty";
  }
  public static get departaments(): string {
    return "/departaments";
  }
  public static get createDepartament(): string {
    return "/createDepartament";
  }
  public static get updateDepartament(): string {
    return "/updateDepartament";
  }
  public static get courses(): string {
    return "/courses";
  }
  public static get createCourse(): string {
    return "/createCourse";
  }
  public static get updateCourse(): string {
    return "/updateCourse";
  }
  public static get enrollmentrequireddocuments(): string {
    return "/enrollmentrequireddocuments";
  }
  public static get createEnrollmentRequiredDocument(): string {
    return "/createEnrollmentRequiredDocument";
  }
  public static get updateEnrollmentRequiredDocument(): string {
    return "/updateEnrollmentRequiredDocument";
  }

  // public static get coursesSubjects(): string {
  // 	return '/coursesSubjects';
  // }
  public static get createCourseSubject(): string {
    return "/createCourseSubject";
  }
  public static get updateCourseSubject(): string {
    return "/updateCourseSubject";
  }
  public static get payStudentDebt(): string {
    return "/payStudentDebt";
  }
  public static get checkPayments(): string {
    return "/checkPayments";
  }

  public static get _(): string {
    return "/";
  }
  public static get users(): string {
    return "/users";
  }
  public static get dashboard(): string {
    return "/dashboard";
  }
  public static get login(): string {
    return "/login";
  }
  public static get createUser(): string {
    return "/createUser";
  }
  public static get updateUser(): string {
    return "/updateUser";
  }
  public static get editMyUser(): string {
    return "/editMyUser";
  }

  public static get roles(): string {
    return "/roles";
  }
  public static get createRole(): string {
    return "/createRole";
  }
  public static get updateRole(): string {
    return "/updateRole";
  }
  public static get addClaimsToRole(): string {
    return "/addClaimsToRole";
  }
  public static get duplicatedSchoolCodes(): string {
    return "/duplicatedSchoolCodes";
  }
  public static get changePassword(): string {
    return "/changePassword";
  }
  public static get changePasswordPolicy(): string {
    return "/changePasswordPolicy";
  }
  public static get unauthorized(): string {
    return "/unauthorized";
  }
  public static get pdfPreview(): string {
    return "/pdfPreview";
  }
  public static get forgotPassword(): string {
    return "/forgotPassword";
  }
  public static get newPassword(): string {
    return "/newPassword";
  }
  public static get userRoleAndCLaims(): string {
    return "/userRoleAndCLaims";
  }

  public static get __(): string {
    return "*";
  }

  public static get academicYears(): string {
    return "/academicYears";
  }
  public static get scientificAreas(): string {
    return "/scientificAreas";
  }
  public static get createScientificAreas(): string {
    return "/createScientificAreas";
  }
  public static get updateScientificAreas(): string {
    return "/updateScientificAreas";
  }

  public static get academicPeriods(): string {
    return "/academicperiods";
  }

  public static get createAcademicPeriod(): string {
    return "/createAcademicPeriod";
  }

  public static get updateAcademicPeriod(): string {
    return "/updateAcademicPeriod";
  }

  public static get subjects(): string {
    return "/subjects";
  }

  public static get createSubject(): string {
    return "/createSubject";
  }

  public static get updateSubject(): string {
    return "/updateSubject";
  }

  public static get createStudent(): string {
    return "/createStudent";
  }

  public static get createEnrollment(): string {
    return "/createEnrollment";
  }
  public static get bulkEnrollmentByExcelFile(): string {
    return "/bulkEnrollmentByExcelFile";
  }
  public static get renewEnrollment(): string {
    return "/renewEnrollment";
  }

  public static get updateEnrollment(): string {
    return "/updateEnrollment";
  }
  public static get teacherClasses(): string {
    return "/teacherClasses";
  }

  public static get enrollments(): string {
    return "/enrollments";
  }
  public static get students(): string {
    return "/students";
  }
  public static get studentStatistics(): string {
    return "/studentStatistics";
  }

  public static get createTeacherRequiredDocument(): string {
    return "/createTeacherRequiredDocument";
  }

  public static get updateTeacherRequiredDocument(): string {
    return "/updateTeacherRequiredDocument";
  }

  public static get teacherRequiredDocuments(): string {
    return "/teacherRequiredDocuments";
  }

  public static get createTeacher(): string {
    return "/createTeacher";
  }

  public static get updateTeacher(): string {
    return "/updateTeacher";
  }

  public static get teachers(): string {
    return "/teachers";
  }

  public static get certificate(): string {
    return "/certificate";
  }

  public static get createClass(): string {
    return "/createClass";
  }

  public static get updateClass(): string {
    return "/updateClass";
  }

  public static get classes(): string {
    return "/classes";
  }

  public static get blockOrUnblockStudentGradePosting(): string {
    return "/blockOrUnblockStudentGradePosting";
  }

  public static get assignTeacherClassesSubjects(): string {
    return "/assignTeacherClassesSubjects";
  }

  public static get manageClassStudents(): string {
    return "/manageClassStudents";
  }

  public static get assessments(): string {
    return "/assessments";
  }

  public static get createAssessments(): string {
    return "/createAssessments";
  }

  public static get createGeneralAssessments(): string {
    return "/createGeneralAssessments";
  }

  public static get updateAssessments(): string {
    return "/updateAssessments";
  }
  public static get addStudentGradesV2(): string {
    return "/addStudentGradesV2";
  }
  public static get addStudentGrades(): string {
    return "/addStudentGrades";
  }
  public static get addStudentExamGrades(): string {
    return "/addStudentExamGrades";
  }
  public static get generalStudentGrades(): string {
    return "/generalStudentGrades";
  }
  public static get viewStudentGrades(): string {
    return "/viewStudentGrades";
  }
  public static get viewStudentExamGrades(): string {
    return "/viewStudentExamGrades";
  }
  public static get studentGrades(): string {
    return "/studentGrades";
  }

  public static get createSubscription(): string {
    return "/createSubscription";
  }

  public static get createMySubscription(): string {
    return "/createMySubscription";
  }
  public static get renewMyEnrollment(): string {
    return "/renewMyEnrollment";
  }

  public static get updateSubscription(): string {
    return "/updateSubscription";
  }

  public static get viewSubscription(): string {
    return "/viewSubscription";
  }

  public static get subscriptions(): string {
    return "/subscriptions";
  }
  public static get subscriptionsValidation(): string {
    return "/subscriptionsValidation";
  }
  public static get subscriptionsStatistics(): string {
    return "/subscriptionsStatistics";
  }
  public static get getPaymentReport(): string {
    return "/getPaymentReport";
  }
  public static get getPaymentReferenceStatus(): string {
    return "/getPaymentReferenceStatus";
  }
  public static get subscriptionsStatisticsCourse(): string {
    return "/subscriptionsStatisticsCourse";
  }

  public static get createClassroomType(): string {
    return "/createClassroomType";
  }

  public static get updateClassroomType(): string {
    return "/updateClassroomType";
  }

  public static get classroomTypes(): string {
    return "/classroomTypes";
  }

  public static get createClassroom(): string {
    return "/createClassroom";
  }

  public static get updateClassroom(): string {
    return "/updateClassroom";
  }

  public static get classrooms(): string {
    return "/classrooms";
  }

  public static get updateVacancy(): string {
    return "/updateVacancy";
  }

  public static get createVacancy(): string {
    return "/createVacancy";
  }

  public static get vacancies(): string {
    return "/vacancies";
  }
  public static get planSubject(): string {
    return "/planSubject";
  }
  public static get manageSchedule(): string {
    return "/manageSchedule";
  }
  public static get teacherSchedule(): string {
    return "/teacherSchedule";
  }
  public static get studentSchedule(): string {
    return "/studentSchedule";
  }
  public static get myAssessments(): string {
    return "/myAssessments";
  }
  public static get teacherEvaluationCriterias(): string {
    return "/teacherEvaluationCriterias";
  }
  public static get createTeacherEvaluationCriteria(): string {
    return "/createTeacherEvaluationCriteria";
  }
  public static get updateTeacherEvaluationCriteria(): string {
    return "/updateTeacherEvaluationCriteria";
  }
  public static get studentTeacherEvaluation(): string {
    return "/studentTeacherEvaluation";
  }
  public static get teacherEvaluations(): string {
    return "/teacherEvaluations";
  }
  public static get evaluateTeacher(): string {
    return "/evaluateTeacher";
  }
  public static get studentDocuments(): string {
    return "/studentDocuments";
  }
  public static get requestStudentDocument(): string {
    return "/requestStudentDocument";
  }
  public static get emitStudentDocuments(): string {
    return "/emitStudentDocuments";
  }
  public static get createStudentDocument(): string {
    return "/createStudentDocument";
  }
  public static get printEnrollmentDocs(): string {
    return "/printEnrollmentDocs";
  }

  public static get findStudentGrades(): string {
    return "/findStudentGrades";
  }
  public static get addSubjectPlan(): string {
    return "/addSubjectPlan";
  }
  public static get getSubjectPlans(): string {
    return "/getSubjectPlans";
  }
  public static get createLessonPlan(): string {
    return "/createLessonPlan";
  }
  public static get updateLessonPlan(): string {
    return "/updateLessonPlan";
  }
  public static get lessonPlans(): string {
    return "/lessonPlans";
  }
  public static get manageLessonPlans(): string {
    return "/manageLessonPlans";
  }
  public static get getClassLessonPlans(): string {
    return "/getClassLessonPlans";
  }
  public static get previewLessonPlan(): string {
    return "/previewLessonPlan";
  }

  public static get getManagers(): string {
    return "/getManagers";
  }
  public static get createManager(): string {
    return "/createManager";
  }
  public static get updateManager(): string {
    return "/updateManager";
  }
  public static get assignManager(): string {
    return "/assignManager";
  }
  public static get curriculumGrid(): string {
    return "/curriculumGrid";
  }
  public static get createlateFeeConfig(): string {
    return "/createlateFeeConfig";
  }
  public static get updatelateFeeConfig(): string {
    return "/updatelateFeeConfig";
  }
  public static get lateFeeConfigs(): string {
    return "/lateFeeConfigs";
  }
  public static get createPaymentType(): string {
    return "/createPaymentType";
  }
  public static get updatePaymentType(): string {
    return "/updatePaymentType";
  }
  public static get paymentTypes(): string {
    return "/paymentTypes";
  }
  public static get createPaymentMethod(): string {
    return "/createPaymentMethod";
  }
  public static get updatePaymentMethod(): string {
    return "/updatePaymentMethod";
  }
  public static get paymentMethods(): string {
    return "/paymentMethods";
  }
  public static get createStudentDebt(): string {
    return "/createStudentDebt";
  }
  public static get checkStudentDebtByStudent(): string {
    return "/checkStudentDebtByStudent";
  }
  public static get updateStudentDebt(): string {
    return "/updateStudentDebt";
  }
  public static get studentDebts(): string {
    return "/studentDebts";
  }
  public static get irregularStudentDebts(): string {
    return "/irregularStudentDebts";
  }
  public static get getStudentFinanceState(): string {
    return "/getStudentFinanceState";
  }
  public static get getStudentFinanceNotifications(): string {
    return "/getStudentFinanceNotifications";
  }
  public static get getFinanceReports(): string {
    return "/getFinanceReports";
  }
  public static get getSchoolBankConfig(): string {
    return "/getSchoolBankConfig";
  }
  public static get createSchoolBankConfig(): string {
    return "/createSchoolBankConfig";
  }
  public static get updateSchoolBankConfig(): string {
    return "/updateSchoolBankConfig";
  }
  public static get createProcessModel(): string {
    return "/createProcessModel";
  }
  public static get updateProcessModel(): string {
    return "/updateProcessModel";
  }
  public static get processModels(): string {
    return "/processModels";
  }
  // public static get courseSubjectV2(): string {
  // 	return '/courseSubjectV2';
  // }
  public static get entities(): string {
    return "/entities";
  }
  public static get subEntities(): string {
    return "/subEntities";
  }
  public static get createEntity(): string {
    return "/createEntity";
  }
  public static get updateEntity(): string {
    return "/updateEntity";
  }
  public static get createSubEntity(): string {
    return "/createSubEntity";
  }
  public static get updateSubEntity(): string {
    return "/updateSubEntity";
  }
  public static get exhibitors(): string {
    return "/exhibitors";
  }
  public static get createExhibitor(): string {
    return "/createExhibitor";
  }
  public static get updateExhibitor(): string {
    return "/updateExhibitor";
  }

  public static get exhibitorsProjects(): string {
    return "/exhibitorsProjects";
  }
  public static get createExhibitorProject(): string {
    return "/createExhibitorProject";
  }
  public static get updateExhibitorProject(): string {
    return "/updateExhibitorProject";
  }

  public static get judges(): string {
    return "/judges";
  }
  public static get createJudge(): string {
    return "/createJudge";
  }
  public static get updateJudge(): string {
    return "/updateJudge";
  }

  public static get judgePhaseProjects(): string {
    return "/judgePhaseProjects";
  }
  public static get createJudgePhaseProject(): string {
    return "/createJudgePhaseProject";
  }
  public static get projectsAssignedToJudge(): string {
    return "/projectsAssignedToJudge";
  }
  public static get updateJudgePhaseProject(): string {
    return "/updateJudgePhaseProject";
  }

  public static get judgePhaseProjectDocuments(): string {
    return "/judgePhaseProjectDocuments";
  }
  public static get createJudgePhaseProjectDocument(): string {
    return "/createJudgePhaseProjectDocument";
  }
  public static get updateJudgePhaseProjectDocument(): string {
    return "/updateJudgePhaseProjectDocument";
  }

  public static get phases(): string {
    return "/phases";
  }
  public static get createPhase(): string {
    return "/createPhase";
  }
  public static get updatePhase(): string {
    return "/updatePhase";
  }

  public static get projects(): string {
    return "/projects";
  }
  public static get createProject(): string {
    return "/createProject";
  }
  public static get updateProject(): string {
    return "/updateProject";
  }
  public static get viewProjectSteps(): string {
    return "/viewProjectSteps";
  }
  public static get projectExpenses(): string {
    return "/projectExpenses";
  }
  public static get createProjectExpense(): string {
    return "/createProjectExpense";
  }
  public static get updateProjectExpense(): string {
    return "/updateProjectExpense";
  }

  public static get projectTypes(): string {
    return "/projectTypes";
  }
  public static get createProjectType(): string {
    return "/createProjectType";
  }
  public static get updateProjectType(): string {
    return "/updateProjectType";
  }

  public static get projectsDocuments(): string {
    return "/projectsDocuments";
  }
  public static get createProjectsDocument(): string {
    return "/createProjectsDocument";
  }
  public static get updateProjectsDocument(): string {
    return "/updateProjectsDocument";
  }
  public static get validateProjectStep(): string {
    return "/validateProjectStep";
  }
  public static get myProjectsAsExbitors(): string {
    return "/myProjectsAsExbitors";
  }

  public static get categories(): string {
    return "/categories";
  }
  public static get createCategory(): string {
    return "/createCategory";
  }
  public static get updateCategory(): string {
    return "/updateCategory";
  }

  public static get authors(): string {
    return "/authors";
  }
  public static get createAuthor(): string {
    return "/createAuthor";
  }
  public static get updateAuthor(): string {
    return "/updateAuthor";
  }
  public static get books(): string {
    return "/books";
  }
  public static get createBook(): string {
    return "/createBook";
  }
  public static get updateBook(): string {
    return "/updateBook";
  }
  public static get bookAuthors(): string {
    return "/bookAuthors";
  }
  public static get createBookAuthor(): string {
    return "/createBookAuthor";
  }
  public static get updateBookAuthor(): string {
    return "/updateBookAuthor";
  }
  public static get manageBookAuthors(): string {
    return "/manageBookAuthors";
  }

  public static get loans(): string {
    return "/loans";
  }
  public static get createLoan(): string {
    return "/createLoan";
  }
  public static get updateLoan(): string {
    return "/updateLoan";
  }
  public static get reservations(): string {
    return "/reservations";
  }
  public static get createReservation(): string {
    return "/createReservation";
  }
  public static get updateReservation(): string {
    return "/updateReservation";
  }
  public static get libraryStats(): string {
    return "/libraryStats";
  }
  public static get uploadPaymentFile(): string {
    return "/uploadPaymentFile";
  }

  public static get createCoursePayment(): string {
    return "/createCoursePayment";
  }
  public static get updateCoursePayment(): string {
    return "/updateCoursePayment";
  }
  public static get coursePayments(): string {
    return "/coursePayments";
  }

  public static get universities(): string {
    return "/universities";
  }
  public static get createUniversity(): string {
    return "/createUniversity";
  }
  public static get updateUniversity(): string {
    return "/updateUniversity";
  }

  public static get knowledgeDomains(): string {
    return "/knowledgeDomains";
  }
  public static get createKnowledgeDomain(): string {
    return "/createKnowledgeDomain";
  }
  public static get updateKnowledgeDomain(): string {
    return "/updateKnowledgeDomain";
  }

  public static get knowledgeSubDomains(): string {
    return "/knowledgeSubDomains";
  }
  public static get createKnowledgeSubDomain(): string {
    return "/createKnowledgeSubDomain";
  }
  public static get updateKnowledgeSubDomain(): string {
    return "/updateKnowledgeSubDomain";
  }

  public static get academicLevels(): string {
    return "/academicLevels";
  }
  public static get createAcademicLevel(): string {
    return "/createAcademicLevel";
  }
  public static get updateAcademicLevel(): string {
    return "/updateAcademicLevel";
  }

  public static get formationAreas(): string {
    return "/formationAreas";
  }
  public static get createFormationArea(): string {
    return "/createFormationArea";
  }
  public static get updateFormationArea(): string {
    return "/updateFormationArea";
  }

  public static get studentSituations(): string {
    return "/studentSituations";
  }
  public static get createStudentSituation(): string {
    return "/createStudentSituation";
  }
  public static get updateStudentSituation(): string {
    return "/updateStudentSituation";
  }
  public static get coursePlans(): string {
    return "/coursePlans";
  }
  public static get createCoursePlan(): string {
    return "/createCoursePlan";
  }
  public static get updateCoursePlan(): string {
    return "/updateCoursePlan";
  }
  public static get scholarshipTypes(): string {
    return "/scholarshipTypes";
  }
  public static get createScholarshipType(): string {
    return "/createScholarshipType";
  }
  public static get updateScholarshipType(): string {
    return "/updateScholarshipType";
  }
  public static get scholarshipProviders(): string {
    return "/scholarshipProviders";
  }
  public static get createScholarshipProvider(): string {
    return "/createScholarshipProvider";
  }
  public static get updateScholarshipProvider(): string {
    return "/updateScholarshipProvider";
  }
  public static get scholarships(): string {
    return "/scholarships";
  }
  public static get createScholarship(): string {
    return "/createScholarship";
  }
  public static get updateScholarship(): string {
    return "/updateScholarship";
  }
  public static get planSubjects(): string {
    return "/planSubjects";
  }
  public static get createUpdatePlanSubjects(): string {
    return "/createUpdatePlanSubjects";
  }
  public static get addSubjectPlanCourse(): string {
    return "/addSubjectPlanCourse";
  }
  public static get studentSubscription(): string {
    return "/studentSubscription";
  }
  public static get syncStudentsEsuraCentral(): string {
    return "/syncStudentsEsuraCentral";
  }

  public static get studentGeneralGrades(): string {
    return "/studentGeneralGrades";
  }

  public static get ctas(): string {
    return "/ctas";
  }

  public static get createCta(): string {
    return "/createCta";
  }

  public static get assignCta(): string {
    return "/assignCta";
  }

  public static get updateCta(): string {
    return "/updateCta";
  }

  public static get createOrEditStudentSubjectGrades(): string {
    return "/createOrEditStudentSubjectGrades";
  }

  public static get uploadStudentCertificate(): string {
    return "/uploadStudentCertificate";
  }
  public static get createAcademicYear(): string {
    return "/createAcademicYear";
  }

  public static get settings(): string {
    return "/Settings";
  }

  public static get CriarAcademicYearFormValidation(): string {
    return "/CriarAcademicYearFormValidation"
  }

  public static get imagens(): string {
    return "/Imagens"
  };
  public static get monthPayments(): string {
    return "/monthPayments";
  }

  public static get Tema(): string {
    return "/Tema"
  };

  public static get UploadModels(): string {
    return "/UploadModels"
  }

  public static get getPaymentReferenceReportAdvanced(): string {
    return "/getPaymentReferenceReportAdvanced"
  };
  public static routeName(route: string): string {
    return route.replace("/", "");
  }
public static get navigationLogs(): string {
    return "/navigationLogs"
  };

}
